module.exports = __webpack_public_path__ + "static/media/WeeklySlots.5a1ca876.svg";